// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";

const brandsAndSolutionsUrl = "/api/guest/spire/header/menuContent";

interface FeaturedBrand {
    title: string | null;
    content: string;
    image: string;
    featuredProducts: string;
    id: string;
    detailPagePath: string;
    brandName: string;
    hasItems: boolean;
}

interface Solution {
    content: string;
    title: string;
    image: string;
    featuredProducts: string;
    hasItems: boolean;
    detailPagePath: string;
}

export interface BrandsItem {
    brandPageTitle: string;
    brandPageUrl: string;
    headerFeaturedBrands: FeaturedBrand[];
    marketingGeneralPromotionTitle: string;
    marketingGeneralPromoContent: string;
    marketingGeneralPromoImage: string | null;
    marketingFeaturedProducts: string;
}

export interface SolutionsItem {
    headerSolutions: Solution[];
    marketingGeneralPromotionTitle: string;
    marketingGeneralPromoContent: string;
    marketingGeneralPromoImage: string;
    marketingFeaturedProducts: string;
    solutionPageUrl: string;
    solutionPageTitle: string;
}

export interface BrandsAndSolutionsModel {
    item1?: BrandsItem;
    item2?: SolutionsItem;
}

export async function getBrandsAndSolutions(): Promise<BrandsAndSolutionsModel> {
    const brandsAndSolutions = await get<BrandsAndSolutionsModel>(brandsAndSolutionsUrl);
    return brandsAndSolutions;
}
